import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import * as moment from 'moment';
import { SelectItem } from 'primeng/components/common/api';
import { UserComplex, User } from '../../../models/user.model';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { CompaniesService } from '../../../services/company/companies.service';
import { RolesService } from '../../../services/user/roles.service';
import { UsersService } from '../../../services/user/users.service';

@Component({
  selector: 'app-user-form',
  templateUrl: 'userForm.component.html',
  styleUrls: ['user-form.css']
})

export class UserFormComponent implements OnChanges, OnInit {

  @Output() userAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() userUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxUser: UserComplex;
  @ViewChild('dateStartField', {read: ElementRef}) dateStartField: ElementRef;
  @ViewChild('dateEndField', {read: ElementRef}) dateEndField: ElementRef;
  addEditForm: FormGroup;
  companies: SelectItem[];
  isNew = true;
  invalidSubmit: boolean;
  fields: any;
  public maxDate: Date = new Date();
  externalUser = false;
  sendEmail = false;

  validators = {
    emailOrEmpty: KoncentroValidators.emailOrEmpty
  }

  @Input() userToClone: {id: number; roleId: number; companies: number[]};

  constructor(
    private fb: FormBuilder,
    public srvRoles: RolesService,
    private srvUsers: UsersService,
    private srvCompany: CompaniesService,
    public srvCalTranslate: CalendarTranslateService
  ) { }

  ngOnInit(): void {
    this.srvRoles.getAll().subscribe();
    this.srvUsers.getFields().subscribe(res => this.fields = { ...res[0], ...res[1] }); // unisco i risultati di UserDto e UserPostDto in un unico oggetto fields
    this.companies = [];
    this.srvCompany.getAll().subscribe((data) => {
      data.forEach((c) => {
        this.companies.push({ value: c.id, label: c.name });
      });
    });
  }

  ngOnChanges() {
    if (this.dialogBoxUser.user.id) {
      this.isNew = false;
    }

    this.externalUser = !!+this.dialogBoxUser.user.flg_ext;

    this.addEditForm = this.fb.group({
      'user': this.fb.group({
        'login': new FormControl(this.dialogBoxUser.user.login),
        'name': new FormControl(this.dialogBoxUser.user.name),
        'surname': new FormControl(this.dialogBoxUser.user.surname),
        'email': new FormControl(this.dialogBoxUser.user.email),
        'role_id': new FormControl(this.dialogBoxUser.user.role_id),
        'flg_ext': new FormControl(this.externalUser),
        'send_email': new FormControl(this.sendEmail)
      }),
      'companies': (this.isNew) ? new FormControl(this.dialogBoxUser.companies) : null,
      'date_start': (this.isNew) ? new FormControl(this.dialogBoxUser.date_start, KoncentroValidators.dateNotAfter(this.maxDate)) : null,
      'date_end': (this.isNew) ? new FormControl(this.dialogBoxUser.date_end, KoncentroValidators.dateNotAfter(this.maxDate)) : null
    });

    if (this.userToClone) {
      this.addEditForm.get('user').get('role_id').setValue(this.userToClone.roleId);
      this.addEditForm.get('companies').setValue(this.userToClone.companies);
    }
  }

  saveOrUpdate(dialogBox: any): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    if (this.isNew) {
      this.addEditForm.value.date_start = moment(this.addEditForm.value.date_start).format('YYYY-MM-DD');
      this.addEditForm.value.date_end = moment(this.addEditForm.value.date_end).format('YYYY-MM-DD');
    }
    const user = new User();
    user.id = this.dialogBoxUser.user.id;
    user.role_id = this.addEditForm.value.user.role_id;
    user.login = this.addEditForm.value.user.login;
    user.email = this.addEditForm.value.user.email;
    user.name = this.addEditForm.value.user.name;
    user.surname = this.addEditForm.value.user.surname;
    user.pwd_expiry = this.dialogBoxUser.user.pwd_expiry;
    user.flg_ext = this.externalUser ? 1 : 0;

    if (this.isNew) {
      user.send_email = this.sendEmail ? 1 : 0;
    }

    let newData = Object.assign({}, this.dialogBoxUser, this.addEditForm.value);
    newData.user = user;
    if (newData.user.id == null) {
      this.userAdded.emit(newData);
    } else {
      this.userUpdated.emit(newData);
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/views/administration/users/userForm.component.ts